export default ({ type, label }) => {
    window.dataLayer.push({
        event: 'GAevent',
        eventCategory: 'Booking_Interactions_CM',
        eventAction: type,
        eventLabel: label,
    });
};

